var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M21.9999 12.0127C21.9999 17.5367 17.5229 22.0127 11.9999 22.0127C6.47688 22.0127 1.99988 17.5367 1.99988 12.0127C1.99988 6.4907 6.47688 2.0127 11.9999 2.0127C17.5229 2.0127 21.9999 6.4907 21.9999 12.0127Z",
    fill: "#03997B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.87 12.6436C12.87 13.1256 12.477 13.5186 11.995 13.5186C11.513 13.5186 11.12 13.1256 11.12 12.6436V8.22363C11.12 7.74163 11.513 7.34863 11.995 7.34863C12.477 7.34863 12.87 7.74163 12.87 8.22363V12.6436ZM11.125 15.8164C11.125 15.3344 11.516 14.9414 11.995 14.9414C12.488 14.9414 12.88 15.3344 12.88 15.8164C12.88 16.2984 12.488 16.6914 12.005 16.6914C11.52 16.6914 11.125 16.2984 11.125 15.8164Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.422a1fd305e18744878a049eb181bc8d.svg";
export { ForwardRef as ReactComponent };